import { GET_BOOKING } from '../graphql/queries/getBooking';
import { MUTATE_BOOKING } from '../graphql/mutations/booking';
import { SET_BOOKING_DETAILS,  BOOKING_DETAILS_LOADING } from './types';
import { get } from '../helpers/objectHelper';
import { store } from '../index';




/**
 * Fetch booking
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} uuid - id of the booking
 */
export async function FetchBooking(client, uuid){
    try{
        await store.dispatch({type:BOOKING_DETAILS_LOADING, payload:true});
        const response = await client.query({query:GET_BOOKING, variables:{uuid:uuid}, fetchPolicy:"no-cache"});    
        await store.dispatch({ type:SET_BOOKING_DETAILS, payload:response.data.getBooking});
        await store.dispatch({type:BOOKING_DETAILS_LOADING, payload:false});
        return response;
    }
   catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            const hasResponseUrl = get([0, 'extensions', 'response', 'url'], graphQLErrors, "");
            const hasReponseStatus = get([0, 'extensions', 'response', 'status'], graphQLErrors, "");
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500 || graphQLErrors[0].message){ 
                window.location.href = `${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ERROR_PAGE}`;
            }
            return graphQLErrors[0].message;
        }
    }
}


/**
 * Fetch booking
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} bookingUUID - id of the booking
 * @param {string} currency - iso currency code
 * @param {string} date - new start date
 * @param {boolean} persist - save to DB - Default: false
 * @param {boolean} resolveGaps - auto resolve new itinerary gaps - Default: true
 */
export async function MutateBooking(client, bookingUUID, currency, date, persist, resolveGaps){
    try{
        await store.dispatch({type:BOOKING_DETAILS_LOADING, payload:true});
        const response = await client.mutate({mutation:MUTATE_BOOKING, variables:{bookingUUID:bookingUUID, currency:currency, date:date, persist:persist, resolveGaps:resolveGaps}});
        await store.dispatch({type:BOOKING_DETAILS_LOADING, payload:false});
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors.length > 0){
            const hasResponseUrl = get([0, 'extensions', 'response', 'url'], graphQLErrors, "");
            const hasReponseStatus = get([0, 'extensions', 'response', 'status'], graphQLErrors, "");
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500 || graphQLErrors[0].message){ 
                window.location.href = `${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ERROR_PAGE}`;
            }
            return graphQLErrors[0].message;
        }
    }
}



